import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var Certification =
/*#__PURE__*/
function (_BaseData) {
  _inherits(Certification, _BaseData);

  function Certification() {
    _classCallCheck(this, Certification);

    return _possibleConstructorReturn(this, _getPrototypeOf(Certification).call(this, "Certification"));
  }

  _createClass(Certification, [{
    key: "CreateCertificationByUserID",
    value: function () {
      var _CreateCertificationByUserID = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(userId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/CreateCertificationByUserID/").concat(userId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function CreateCertificationByUserID(_x) {
        return _CreateCertificationByUserID.apply(this, arguments);
      }

      return CreateCertificationByUserID;
    }()
  }]);

  return Certification;
}(BaseData);

export default new Certification();